<script setup>
import Updates from "@/views/enterprise/home/aside/updates/Updates.vue";
import CompanyDetails from "@/views/enterprise/home/aside/CompanyDetails.vue";
import { useStore } from "vue2-helpers/vuex";
import { inject } from "vue";

const store = useStore();
const collapsed = inject('asideCollapsed');

const toggleCollapsed = () => {
    collapsed.value = !collapsed.value;
};
</script>

<template>
    <aside class="aside aside--homepage" :class="{ 'aside--collapsed': collapsed }">
        <a v-if="store.getters.isDaikinEnterprise" @click="toggleCollapsed" class="aside__collapse"></a>
        <div class="aside__inner">
            <div
                class="aside__inner__section"
                :class="{'no-radius': store.getters.isDaikinEnterprise}"
            >
                <CompanyDetails/>
            </div>
            <div
                v-if="store.getters.isPremiumEnterprise"
                class="aside__inner__section"
            >
                <Updates/>
            </div>
        </div>
    </aside>
</template>

<style scoped>
    .aside {
        @media (min-width: 1025px) {
            .aside__collapse {
                position: absolute;
                top: 0;
                z-index: -1;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-top: 31px;
                width: 50px;
                height: 53px;
                background: #016d94;
                border-radius: 26px 0 0 26px;
                cursor: pointer;

                &::before {
                    content: "";
                    position: relative;
                    /*NOTE: remove from here, we have the same in the css. Test before*/
                    top: 0;
                    display: block;
                    width: 12px;
                    height: 12px;
                    background: url('../../../../images/minimize.svg') no-repeat center;
                    background-size: auto 12px;
                    transform: rotate(180deg);
                    transition: transform 0.6s;
                }
                &:hover {
                    text-decoration: none;
                }
            }
        }
    }
</style>
